import { render, staticRenderFns } from "./formatManage.vue?vue&type=template&id=3c539c78&scoped=true&"
import script from "./formatManage.vue?vue&type=script&lang=js&"
export * from "./formatManage.vue?vue&type=script&lang=js&"
import style0 from "./formatManage.vue?vue&type=style&index=0&id=3c539c78&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c539c78",
  null
  
)

export default component.exports